import { create } from "zustand";
import { persist } from "zustand/middleware";
import { ModuleI, OptionI } from "../../interfaces"; // Ajusta según tu estructura

type state = {
  modulesBackup: ModuleI[];
  optionsBackup: OptionI[];
  setModulesBackup: (modules: ModuleI[]) => void;
  setOptionsBackup: (modules: OptionI[]) => void;
};

const initialState: state = {
  modulesBackup: [],
  optionsBackup: [],
  setModulesBackup: (modules: ModuleI[]) => null,
  setOptionsBackup: (options: OptionI[]) => null,
};

export const useModulesBackupStore = create<state>()(
  persist(
    (set, get) => ({
      modulesBackup: [],
      optionsBackup: [],
      setModulesBackup: (modules) => set({ modulesBackup: modules }),
      setOptionsBackup: (options) => set({ optionsBackup: options }),
    }),
    {
      name: process.env.REACT_APP_TOKEN_ROUTER_BACKUP!, // Clave diferente para evitar conflictos
    }
  )
);
